import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class CteService extends CommonService {
  getCte(page, qntdNfe, empresa, range, urlFiltros) {
    let url =
      "ctes/empresa/" +
      empresa +
      "?_page=" +
      page +
      "&_pagesize=" +
      qntdNfe +
      "&_range=" +
      range;

    urlFiltros != undefined ? (url += urlFiltros) : "";
    return this._resource.get(url).then(
      success => {
        return success.body;
      },
      failed => {
        return failed;
      }
    );
  }

  sendXml(id_empresa, file) {
        
    const data = new FormData();
    data.append("file", file);

    let url = `ctes/uploadxml/${id_empresa}`;

    return this._resource.post(url, data).then(success => {

        return success;
    }, failed => {

        return failed;
    })
}
  getCteTomados(page, qntdNfe, empresa, range, urlFiltros) {
    let url =
      "ctes/empresa/" +
      empresa +
      "?_page=" +
      page +
      "&_pagesize=" +
      qntdNfe +
      "&_range=" +
      range +
      "&_tomadas=true";

    urlFiltros != undefined ? (url += urlFiltros) : "";
    return this._resource.get(url).then(
      success => {
        return success.body;
      },
      failed => {
        return failed;
      }
    );
  }
  getXml(id_nota) {
    return this._resource.get("ctes/xml/" + id_nota).then(
      success => {
        return success.body.xml;
      },
      failed => {
        console.log(failed);
      }
    );
  }
  consultaAvulsaNota(id_empresa) {
    return this._resource.get("ctes/busca/" + id_empresa).then(
      success => {
        return success;
      },
      failed => {
        return failed;
      }
    );
  }
  getNfeByChave(chave) {
    return this._resource.get("nfes/chave/" + chave).then(
      success => {
        return this.getDanfe(success.body.idNF);
      },
      failed => {
        console.log(failed);
      }
    );
  }
  getDanfe(id_nota) {
    return this._resource.get("nfes/danfe/" + id_nota).then(
      success => {
        var data = new Uint8Array(success.body.danfe.data);
        return this.bufferToBase64(data);
      },
      failed => {
        console.log(failed);
      }
    );
  }

  getDacte(id_nota) {
    return this._resource.get("ctes/pdf/" + id_nota).then(
      success => {
        var data = new Uint8Array(success.body.danfe.data);
        return this.bufferToBase64(data);
      },
      failed => {
        console.log(failed);
      }
    );
  }

  desacordo(chave, id_empresa, just) {
    const obj = {
        chave,
        obs: just
    }
    const body = JSON.stringify(obj);
    console.log("ctes/manifestacao/" + id_empresa, body);

    return this._resource.post("ctes/manifestacao/" + id_empresa, body).then(
        success => {
        },
        failed => {
            let message = failed.body.message.replace(/Desacordo: /gi, "");
            return message;

        }
    );

}
}



// WEBPACK FOOTER //
// ./src/domain/notas/cte/CteService.js